import { differenceInCalendarDays } from 'date-fns'
import { dateParamType } from '~/utils/gcxDates/toDate'
import { removeTZFromDate } from '~/utils/gcxDates/removeTZFromDate'

type getCalendarDaysDiffType = (
  leftDate: dateParamType,
  rightDate: dateParamType,
) => number

/**
 * @returns a number of days between the dates interval
 */

export const getCalendarDaysDiff: getCalendarDaysDiffType = (start, end) => {
  start = removeTZFromDate(start)
  end = removeTZFromDate(end)

  return differenceInCalendarDays(end, start)
}
